// react-i18next 전역 인스턴스. src/index.js 에서 side-effect import 로 최초 로드.
//
// UI 언어의 단일 소스는 lang.store 다. 이 파일은 store → i18next.changeLanguage +
// <html lang/dir> 를 잇는다(구독). 리소스는 정적 import(인앱 페이지 우선 범위라
// 번들 부담이 작다) — 필요 시 지연 로드로 전환 가능.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { useLangStore, isRtl, UI_LOCALES } from '../stores/lang.store';

import en from './locales/en/common.json';
import ko from './locales/ko/common.json';
import id from './locales/id/common.json';
import ms from './locales/ms/common.json';
import ar from './locales/ar/common.json';

const initialLang = useLangStore.getState().lang;

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
    ko: { common: ko },
    id: { common: id },
    ms: { common: ms },
    ar: { common: ar },
  },
  lng: initialLang,
  fallbackLng: 'en',
  supportedLngs: UI_LOCALES.map((l) => l.code),
  ns: ['common'],
  defaultNS: 'common',
  interpolation: { escapeValue: false }, // React 가 XSS 방어
  returnEmptyString: false,
  react: { useSuspense: false }, // 리소스가 정적이라 Suspense 불필요
});

function applyHtmlLangDir(code: string) {
  if (typeof document === 'undefined') return;
  const el = document.documentElement;
  el.lang = code;
  el.dir = isRtl(code) ? 'rtl' : 'ltr';
}

applyHtmlLangDir(initialLang);

// store 변경(Footer 선택기 등) → i18n + <html> 반영.
useLangStore.subscribe((state) => {
  if (i18n.language !== state.lang) i18n.changeLanguage(state.lang);
  applyHtmlLangDir(state.lang);
});

export default i18n;
